import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { api } from '../api/client';
import { AuthLayout } from '../components/auth/AuthLayout';
import { Banner, Spinner } from '../components/ui';

const ImpersonatePage: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const token = searchParams.get('token');
        if (!token) {
            navigate('/', { replace: true });
            return;
        }

        // Exchange the one-time JWT for an HttpOnly cookie in this browser session.
        // This ensures the cookie is set for this window (private window) rather than
        // the admin's browser session that initiated the impersonation request.
        api.get(`/impersonate/activate?token=${encodeURIComponent(token)}`)
            .then((res) => {
                // Set a flag so the banner shows (we don't store the token itself)
                sessionStorage.setItem('impersonationActive', res.data.email || 'Unbekannt');
                // Cookie is now set for this session. Navigate to dashboard.
                window.location.replace('/dashboard');
            })
            .catch(() => {
                setError('Impersonation-Link ist ungültig oder abgelaufen.');
            });
    }, [searchParams, navigate]);

    if (error) {
        return (
            <AuthLayout title="Anmeldung fehlgeschlagen">
                <Banner tone="danger">{error}</Banner>
            </AuthLayout>
        );
    }

    return (
        <AuthLayout title="Anmeldung wird aktiviert">
            <div className="flex flex-col items-center gap-3 py-4 text-center">
                <Spinner size={28} />
                <p className="text-muted">Impersonation wird aktiviert…</p>
            </div>
        </AuthLayout>
    );
};

export default ImpersonatePage;
